module.exports = __webpack_public_path__ + "img/5視聽室.7e74a0df.jpg";